import { MutationTree } from 'vuex';
import { CallIvrMenusState } from './types';

export const mutations: MutationTree<CallIvrMenusState> = {
    pushIvrMenus:(state, data) => {
        state.ivrMenus = state.ivrMenus.concat(data)
    },
    setIvrMenus:(state, data) => {
        state.ivrMenus = data
    },
    setIvrMenuItem:(state, data) => {
        state.ivrMenuItem = data
    },
};
